// @packages
import { bindActionCreators } from 'redux';

// @scripts
import { config } from '../config';
import { format, getBaseUrl, navigateToUrl } from '../helpers';

import {
    formModalDialogValid,
    hideLoadingPage,
    hideModalDialog,
    hideToastNotification,
    showLoadingPage,
    showModalDialog,
    showToastNotification,
    showToastNotificationError,
    showToastNotificationInfo,
    showToastNotificationSuccess,
    showToastNotificationWarning
} from '../actions';

/**
 * @param {Store} store - The redux store.
 * @return {Object}
 */
export const initializeGlobalUI = (store, environment) => {
    const globalUI = bindActionCreators({
        showLoadingPage,
        showToastNotification,
        showToastNotificationError,
        showToastNotificationInfo,
        showToastNotificationSuccess,
        showToastNotificationWarning
    }, store.dispatch);

    globalUI.showModalDialog = ({
        cancelLabel,
        msg,
        msgArgs,
        okLabel,
        onConfirm,
        showCancel,
        style,
        title,
        width
    }) => {
        const onConfirmCallback = onConfirm
            ? () => { globalUI.hideModalDialog(); onConfirm(); }
            : null;

        store.dispatch(showModalDialog({
            cancelLabel: cancelLabel || config.text.modalDialog.cancel,
            msg: msg || config.text.modalDialog.msg,
            msgArgs,
            okLabel: okLabel || config.text.modalDialog.ok,
            onConfirm: onConfirmCallback,
            showCancel,
            style,
            title: title || config.text.modalDialog.title,
            width
        }));
    };

    globalUI.formModalDialogValid = (isValid) => {
        store.dispatch(formModalDialogValid(isValid));
    };

    globalUI.hideLoadingPage = () => {
        if (store.getState().loadingPage.isVisible) {
            store.dispatch(hideLoadingPage());
        }
    };

    globalUI.hideToastNotification = () => {
        if (store.getState().toastNotification.isVisible) {
            store.dispatch(hideToastNotification());
        }
    };

    globalUI.hideModalDialog = () => {
        if (store.getState().modalDialog.isVisible) {
            store.dispatch(hideModalDialog());
        }
    };

    globalUI.setBrowserHistory = (browserHistory) => {
        globalUI.browserHistory = browserHistory;
    };

    globalUI.getDefaultUrl = () => {
        const defaultMenu = config.mainMenu.find(
            (menuItem) => menuItem.isDefault === true
        ) || config.mainMenu[0];

        const defaultUrl = defaultMenu
            ? defaultMenu.url
            : getBaseUrl();

        return defaultUrl;
    };

    globalUI.navigateToUrl = (url) => {
        if (globalUI.browserHistory) {
            const { pathname } = globalUI.browserHistory.location;
            if (pathname !== url) {
                globalUI.browserHistory.push(url);
            }
        } else {
            navigateToUrl(`${getBaseUrl()}/#${url}`);
        }
    };

    globalUI.navigateToDefaultUrl = () => {
        globalUI.navigateToUrl(globalUI.getDefaultUrl());
    };

    globalUI.exports = [];

    globalUI.attachExport = (name, fn) => {
        globalUI.exports[name] = fn;
    };

    globalUI.executeExport = (name) => {
        globalUI.exports[name]();
    };

    globalUI.getExports = () => globalUI.exports;

    if (!environment.isUnitTest) {
        globalUI.getImage = (relativePath) => {
            const sourceImage = require.context('../styles/images', true)(relativePath);
            const { buildFolder } = config.settings;
            //return format('{0}{1}', buildFolder !== undefined ? buildFolder : '', sourceImage.default);
            return format('{0}{1}', buildFolder !== undefined ? buildFolder : '', sourceImage);
        };
    }

    return globalUI;
};
